var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"consent-preference-channels"},_vm._l((_vm.resultChannels),function(channel,index){return _c('subscription-preference-channel',{key:index,attrs:{"channel":channel},on:{"open-audit-log":_vm.openAuditLog,"reload-preferences":function($event){return _vm.$emit('reload-preferences')}}})}),1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ec1ff86","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/profiles/components/SubscriptionPreferenceChannels.vue
// module id = null
// module chunks = 